import { i18n } from "~vue/i18n";

// LAB-988 admin campaign report palette. 5-color diverging scale matching the
// mockup: pinks on the "low" side, cream neutral in the middle, indigos on the
// "high" side. Not promoted to design-system tokens yet since these are only
// used inside the reflections admin report.
export const SEGMENT_COLORS = [
    "#cd2f7b", // Rarely — pink
    "#f6a6c5", // Occasionally — light pink
    "#e7e2db", // Sometimes — cream
    "#b7b2ee", // Often — light indigo
    "#7e78de", // Consistently — indigo
] as const;

// Every swatch except the first needs black percentage labels to reach 4.5:1.
// This includes the final indigo; white reaches only 3.73:1 on that swatch.
export const LIGHT_SWATCH_INDICES = new Set([1, 2, 3, 4]);

// Shares its translation keys with the `rarely_consistently` assessment scale
// (BRA-1259) rather than carrying its own copy: both say the same five English
// words, and a second source would let a re-translation of one drift from the
// other.
export function getSegmentLabels(): string[] {
    const { t } = i18n.global;
    return [
        t("assessments.scales.rarely_consistently.points.1"),
        t("assessments.scales.rarely_consistently.points.2"),
        t("assessments.scales.rarely_consistently.points.3"),
        t("assessments.scales.rarely_consistently.points.4"),
        t("assessments.scales.rarely_consistently.points.5"),
    ];
}
